import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2023SGM() {
  return <CategoryPage category="anexo30Y31Ano2023SGM" pageTitle="Sistema de Gestión de Medición 2023" />;
}

export default Anexo30Y31Ano2023SGM;
